import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { fetchPagedComponent } from './helpers/helpers.js';
import { useBloomreach } from '../context/context.js';
import { getContentByRef } from '../utils/get-content-by-ref.js';

function parseBloomreachArticles(pageable, highlighted, pageModel) {
    const { currentPage , nextPage , totalPages , items  } = pageable !== null && pageable !== void 0 ? pageable : {};
    const highlightedContent = highlighted && getContentByRef(highlighted.$ref, pageModel);
    var ref;
    const articles = (ref = items === null || items === void 0 ? void 0 : items.map((item)=>item && getContentByRef(item.$ref, pageModel)
    )) !== null && ref !== void 0 ? ref : [];
    return {
        highlighted: highlightedContent,
        paged: {
            items: articles,
            currentPage,
            nextPage,
            totalPages
        }
    };
}
const useBloomreachArticles = ({ component , page  })=>{
    const { apiUrl  } = useBloomreach();
    const { locale  } = useIntl();
    const { isMultilingualEnabled  } = useFeatureToggles();
    const componentId = component.getId();
    const pageModel = page.toJSON();
    const localeTransformed = locale.replace('-', '_');
    const url = isMultilingualEnabled ? `${apiUrl}/${localeTransformed}` : apiUrl;
    const { pageable: pageable1 , highlightedArticle: highlightedArticle1  } = component.getModels();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const [result, setResult] = React.useState(()=>{
        return parseBloomreachArticles(pageable1, highlightedArticle1, pageModel);
    });
    var _currentPage;
    const [currentPage, setCurrentPage] = React.useState((_currentPage = result.paged.currentPage) !== null && _currentPage !== void 0 ? _currentPage : 1);
    const loadNextPage = React.useCallback(()=>{
        result.paged.nextPage && setCurrentPage(result.paged.nextPage);
    }, [
        result.paged.nextPage
    ]);
    React.useEffect(()=>{
        if (currentPage === result.paged.currentPage) {
            return;
        }
        const path = isMultilingualEnabled ? window === null || window === void 0 ? void 0 : window.location.pathname.replace(`/${localeTransformed}`, '') : window === null || window === void 0 ? void 0 : window.location.pathname;
        let current = true;
        setLoading(true);
        fetchPagedComponent(url, componentId, currentPage, path).then((res)=>{
            if (current) {
                var ref;
                if (res === null || res === void 0 ? void 0 : (ref = res.page) === null || ref === void 0 ? void 0 : ref.models) {
                    const { pageable , highlightedArticle  } = res.page.models;
                    const { paged  } = parseBloomreachArticles(pageable, highlightedArticle, res);
                    setResult((state)=>swcHelpers.objectSpread({}, state, {
                            paged: swcHelpers.objectSpread({}, paged, {
                                items: [
                                    ...state.paged.items,
                                    ...paged.items
                                ]
                            })
                        })
                    );
                }
                setLoading(false);
            }
        }).catch((err)=>{
            if (current) {
                console.error(err);
                setError(err);
                setLoading(false);
            }
        });
        return ()=>{
            current = false;
        };
    }, [
        url,
        currentPage,
        result.paged.currentPage,
        page,
        componentId,
        isMultilingualEnabled,
        localeTransformed, 
    ]);
    return {
        loading,
        error,
        result,
        loadNextPage
    };
};

export { useBloomreachArticles };
//# sourceMappingURL=use-bloomreach-articles.js.map
